import React, { useEffect, useState } from 'react';
import FourDotLoader from 'components/FourDotLoader';
import { Navigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import api from 'api';
import { BUSINESS_ROUTE } from 'data/global';
import mixpanelService from 'services/mixpanelService';
import {
  ENQUIRY_ORIGIN,
  EnquiryCreationInitiatedEventProps,
  ErrorViewedProps,
} from 'models/MixpanelEvents';
import { getMixpanelErrorProps } from 'axiosUtils';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { DATA_ROOM_LOGIN_SOURCE } from 'models/DataRoomLoginSource';

type ShareableLinkAccessBeforeNavigateToDrProps = {
  shareableLinkId: string;
  dataRoomId: string;
  dealRoomId: string;
  dealRoomName: string;
  isLead: boolean;
};

const ShareableLinkAccessBeforeNavigateToDr: React.FC<
  ShareableLinkAccessBeforeNavigateToDrProps
> = (props) => {
  const { shareableLinkId, dataRoomId, dealRoomId, dealRoomName, isLead } =
    props;

  const [isLoading, setIsLoading] = useState(true);
  const [isFailed, setIsFailed] = useState(false);

  const getMixpanelProps = useGetMixpanelProps();

  useEffect(() => {
    (async () => {
      try {
        if (!isLead)
          mixpanelService.enquiryCreationInitiated(
            getMixpanelProps({
              dealId: dealRoomId,
              dealName: dealRoomName,
              enquiryOrigin: ENQUIRY_ORIGIN.SECURE_LINK,
            }) as EnquiryCreationInitiatedEventProps,
          );

        await api.shareableLinks.getAccessBeforeDRaccess(shareableLinkId);
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
        setIsFailed(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [shareableLinkId, dealRoomId, dealRoomName, isLead, getMixpanelProps]);

  if (isLoading) return <FourDotLoader />;

  if (isFailed) return <Navigate to={BUSINESS_ROUTE} replace />;

  return (
    <Navigate
      to={getDataRoomRoute(
        dataRoomId,
        'documents',
        DATA_ROOM_LOGIN_SOURCE.SECURE_LINK,
        shareableLinkId,
      )}
      replace
    />
  );
};

export default ShareableLinkAccessBeforeNavigateToDr;
